import { FieldWithLabel, FieldWithLabelProps } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';

export function ProfileFieldWithLabel({ className, children, ...props }: FieldWithLabelProps) {
  return (
    <FieldWithLabel {...props} className={cn('relative text-base font-bold', className)}>
      {children}
    </FieldWithLabel>
  );
}
